import request from '@/utils/request'

export function pager(data) {
  return request({
    url: '/api/projectRest/list',
    method: 'post',
    data,
  })
}

export function getProjectDetail(data) {
  return request({
    url: '/api/getProjectDetailById',
    method: 'post',
    data,
  })
}

export function getAcceptOrderBaseList(data) {
  return request({
    url: '/api/acceptOrderBase/pager',
    method: 'post',
    params: data,
  })
}
export function getClubsList(data) {
  return request({
    url: '/api/project/clubsList',
    method: 'post',
    params: data,
  })
}
